(function () {
  'use strict';

  var configs = window.fcPopupConfigs || [];
  var page    = window.fcCurrentPage  || {};

  if (!configs.length) return;

  /* ── Shopify Theme Editor: preview on block select ─────────────────────── */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (e) {
      var id = 'fcpop-' + e.detail.blockId;
      document.querySelectorAll('.fc-overlay').forEach(function (el) {
        el.classList.toggle('is-open', el.id === id);
      });
      document.body.style.overflow = 'hidden';
    });
    document.addEventListener('shopify:block:deselect', function () {
      document.querySelectorAll('.fc-overlay.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      document.body.style.overflow = '';
    });
    return;
  }

  /* ── Page matching ─────────────────────────────────────────────────────── */
  function currentHandle() {
    var parts = (page.path || '').replace(/^\//, '').split('/');
    return parts[parts.length - 1] || '';
  }

  function matchesHandles(str) {
    if (!str) return false;
    var h = currentHandle().toLowerCase();
    return str.split(',').map(function (s) { return s.trim().toLowerCase(); }).indexOf(h) !== -1;
  }

  function matchesPageType(cfg) {
    return (cfg.targetHomepage       && page.isHomepage)   ||
           (cfg.targetAllCollections && page.isCollection) ||
           (cfg.targetAllProducts    && page.isProduct)    ||
           (cfg.targetAllBlogs       && page.isBlog)       ||
           (cfg.targetCart           && page.isCart);
  }

  function findConfig() {
    // Handle match beats page type; first match wins within each tier
    for (var i = 0; i < configs.length; i++) {
      if (matchesHandles(configs[i].targetHandles)) return configs[i];
    }
    for (var j = 0; j < configs.length; j++) {
      if (matchesPageType(configs[j])) return configs[j];
    }
    return null;
  }

  var cfg = findConfig();
  if (!cfg) return;

  var overlay = document.getElementById(cfg.id);
  if (!overlay) return;

  /* ── Mobile guard ──────────────────────────────────────────────────────── */
  if (cfg.hideOnMobile && window.innerWidth <= 680) return;

  /* ── Show once / frequency ─────────────────────────────────────────────── */
  var STORAGE_KEY = 'fc_popup_seen_' + cfg.id;

  function seen() {
    try {
      if (cfg.frequencyType === 'days') {
        var ts = localStorage.getItem(STORAGE_KEY);
        if (!ts) return false;
        return (Date.now() - parseInt(ts, 10)) < cfg.frequencyDays * 86400000;
      }
      return !!sessionStorage.getItem(STORAGE_KEY);
    } catch (e) { return false; }
  }

  function markSeen() {
    try {
      if (cfg.frequencyType === 'days') {
        localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } else {
        sessionStorage.setItem(STORAGE_KEY, '1');
      }
    } catch (e) {}
  }

  /* ── Open / close ──────────────────────────────────────────────────────── */
  var opened = false;

  function open() {
    if (opened || seen()) return;
    opened = true; markSeen();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    // Reset the confirm step so a re-open shows the form, not the prompt.
    var m = overlay.querySelector('.fc-modal');
    if (m) { m.classList.remove('is-confirming'); }
  }

  // Public API
  window.openFCModal = function () { opened = false; open(); };
  window.openFCPopup = window.openFCModal;

  /* ── Second-chance "Are you sure?" before closing ──────────────────────── */
  var modal        = overlay.querySelector('.fc-modal');
  var confirmEl    = overlay.querySelector('.fc-confirm');
  var confirmShown = false;

  // Intercept the first dismiss attempt to show the confirm step; any
  // dismiss after that (or once converted) closes for real.
  function requestClose() {
    if (cfg.enableConfirm && confirmEl && modal && !confirmShown && !converted) {
      confirmShown = true;
      modal.classList.add('is-confirming');
      var yes = confirmEl.querySelector('.fc-confirm-yes');
      if (yes) { try { yes.focus(); } catch (e) {} }
      return;
    }
    close();
  }

  // Little confetti pop when they decide to stay for the discount.
  function celebrate() {
    if (!confirmEl) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#80D658', '#EDE9E1', '#f75d44', '#ffd23f'];
    var pieces = [];
    var COUNT = 22;
    for (var i = 0; i < COUNT; i++) {
      var p = document.createElement('span');
      p.className = 'fc-confetti';
      p.style.background = colors[i % colors.length];
      var angle = -Math.PI * (0.12 + (i / COUNT) * 0.76); // upward fan
      var dist  = 120 + (i % 6) * 26;
      p.style.setProperty('--fc-cx', (Math.cos(angle) * dist) + 'px');
      p.style.setProperty('--fc-cy', (Math.sin(angle) * dist - 40) + 'px');
      p.style.setProperty('--fc-cr', (180 + i * 40) + 'deg');
      confirmEl.appendChild(p);
      pieces.push(p);
    }
    confirmEl.classList.add('fc-celebrate');
    // Clean up the confetti nodes well after the animation ends.
    setTimeout(function () {
      confirmEl.classList.remove('fc-celebrate');
      pieces.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    }, 1500);
  }

  if (confirmEl) {
    var yesBtn = confirmEl.querySelector('.fc-confirm-yes');
    var noBtn  = confirmEl.querySelector('.fc-confirm-no');
    // "Yes, keep my discount" → celebrate and return to the form.
    if (yesBtn) yesBtn.addEventListener('click', function () {
      celebrate();
      // Hold the confirm panel up so the confetti is fully visible, then
      // return to the signup form.
      setTimeout(function () { if (modal) modal.classList.remove('is-confirming'); }, 1200);
    });
    // "No thanks" → actually close.
    if (noBtn) noBtn.addEventListener('click', close);
  }

  /* ── Event listeners ───────────────────────────────────────────────────── */
  var closeBtn   = document.getElementById(cfg.id + '-close');
  var declineBtn = document.getElementById(cfg.id + '-decline');

  if (closeBtn)   closeBtn.addEventListener('click', requestClose);
  if (declineBtn) declineBtn.addEventListener('click', requestClose);

  if (cfg.closeOnOverlay) {
    overlay.addEventListener('click', function (e) { if (e.target === overlay) requestClose(); });
  }

  if (cfg.closeOnEsc) {
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') requestClose(); });
  }

  /* ── Success state after GHL form submit ───────────────────────────────── */
  var converted = false;

  function onConverted() {
    if (converted) return;
    converted = true;

    var modal = overlay.querySelector('.fc-modal');
    if (!modal) { close(); return; }

    if (!cfg.showSuccess) {
      close();
      return;
    }

    modal.classList.add('is-converted');

    var successCountdownEl = modal.querySelector('.fc-success-countdown');
    var successCloseBtn    = modal.querySelector('.fc-success-close');
    var delay              = cfg.autoCloseDelay; // ms
    var remaining          = Math.round(delay / 1000);
    var tick;

    function updateCountdown() {
      if (!successCountdownEl) return;
      var template = successCountdownEl.getAttribute('data-template') || '';
      successCountdownEl.textContent = template.replace('{s}', remaining);
    }

    if (successCountdownEl) {
      updateCountdown();
      if (delay > 0) {
        tick = setInterval(function () {
          remaining = Math.max(0, remaining - 1);
          updateCountdown();
          if (remaining <= 0) clearInterval(tick);
        }, 1000);
      }
    }

    if (delay > 0) setTimeout(function () { clearInterval(tick); close(); }, delay);

    if (successCloseBtn) {
      successCloseBtn.addEventListener('click', function () {
        clearInterval(tick);
        close();
      });
    }
  }

  /* ── GHL postMessage submit detection ──────────────────────────────────── */
  window.addEventListener('message', function (e) {
    if (!e.data) return;

    // Only accept messages from GHL domains
    var origin = (e.origin || '').toLowerCase();
    var fromGHL = origin.indexOf('leadconnectorhq.com') > -1
               || origin.indexOf('msgsndr.com') > -1
               || origin.indexOf('gohighlevel.com') > -1;
    if (!fromGHL) return;

    var blob = typeof e.data === 'string'
      ? e.data.toLowerCase()
      : JSON.stringify(e.data).toLowerCase();

    // Only fire on definitive GHL submission signals — never on generic 'submit'
    var isSubmit =
      blob.indexOf('customer_id')   > -1 ||
      blob.indexOf('formsubmitted') > -1 ||
      blob.indexOf('form-submitted') > -1 ||
      (blob.indexOf('"email"') > -1 && blob.indexOf('full_name') > -1);

    if (isSubmit) onConverted();
  });

  /* ── Triggers ──────────────────────────────────────────────────────────── */
  if (cfg.openDelay >= 0) {
    setTimeout(open, cfg.openDelay);
  }

  if (cfg.exitIntent) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) open();
    });
  }

  if (cfg.triggerScroll) {
    var scrollFired = false;
    window.addEventListener('scroll', function () {
      if (scrollFired) return;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var pct  = docH > 0 ? (window.scrollY / docH) * 100 : 0;
      if (pct >= cfg.triggerScrollPercent) { scrollFired = true; open(); }
    }, { passive: true });
  }

})();